// Use $ instead of $ without replacing global $
(function ($) {
    $(document).ready(function () {
        $(document).on('click', '.video-active', '.play-video', function (e) {
            e.preventDefault();
            var linkval = $(this).attr('data-video');
            var video_type = $(this).attr('data-type');
            var url = linkval;
            linkval = linkval.split(' ')[0];
            linkval = linkval.split('/')[2];
            if (linkval === 'www.facebook.com') {
                $('.video-overlay .video-container > iframe').css({
                    'display': 'none'
                });
                $(this).parent().find(".fb-video-outer").clone().appendTo(".video-overlay .video-container");
            }
            var autoplay;
            (linkval.indexOf("autoplay=1") > -1) ? autoplay = "": autoplay = "?autoplay=1&mute=1&feature=youtu.be";
            $(".video-overlay").addClass("active");
            $('body').css("overflow", "hidden");
            if ((url.indexOf('youtube') > 0) || (url.indexOf('youtu.be') > 0)) {
                var newUrl = getVideoId(url);
                if ($('.video-overlay .video-container > iframe').length == 0) {
                    $('<iframe src="about:blank" allowfullscreen="" webkitallowfullscreen="" mozallowfullscreen="" playsinline="" allow="autoplay" ></iframe>').appendTo($('.video-overlay .video-container'));
                }
                $('.video-overlay .video-container > iframe').attr("src", "//www.youtube.com/embed/" + newUrl + "?autoplay=1");
            } else if ((url.indexOf('brightcove.net') > 0)) {
                $('.video-overlay .video-container > iframe').attr("src", url + "&autoplay");
            } else if ((url.indexOf('studio.brightcove') > 0) || (video_type == 'brightcove')) {

                var n = url.lastIndexOf('/');
                var video_id = url.substring(n + 1);
                var iframecode = '<video-js id="myPlayerID" data-video-id="' + video_id + '" data-account="6143005691001" data-player="tjJCToaC0" data-embed="default" class="video-js vjs-fluid" controls poster=""></video-js><script src="https://players.brightcove.net/6143005691001/tjJCToaC0_default/index.min.js"></script>';

                $('.video-overlay .video-container ').html(iframecode);
            } else {
                $('.video-overlay .video-container > iframe').attr("src", url + "?autoplay=1");
            }
            $('.video-overlay').css({
                'display': '1',
                'visibility': 'visible'
            });
        });

        $(document).on('click', '.video-overlay .closeVideo', '.video-overlay', function (e) {
            $('.video-overlay').removeClass('active');
            $('.video-overlay').css({
                'display': '0',
                'visibility': 'hidden'
            });
            $('body').css("overflow", "inherit");
            $('.video-overlay iframe').attr("src", "");
            $('.video-overlay .video-container #myPlayerID').remove();
            $('.video-overlay .video-container .fb-video-outer').remove();
        });

        $(document).on('click', '.video-overlay', function (e) {
            $('.video-overlay').removeClass('active');
            $('.video-overlay').css({
                'display': '0',
                'visibility': 'hidden'
            });
            $('body').css("overflow", "inherit");
            $('.video-overlay iframe').attr("src", "");
            $('.video-overlay .video-container .fb-video-outer').remove();
            $('.video-overlay .video-container #myPlayerID').remove();
        });
        $(".video-overlay .video-container").on('click', function (e) {
            // e.stopPropagation(); // Prevent overlay from closing when clicking inside video container
        });

        function getVideoId(url) {
            var regExp = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/;
            var match = url.match(regExp);
            if (match && match[5].length == 11) {
                return match[5];
            } else {
                return 'error';
            }
        }

        // Handle all anchors with .mp4 hrefs
        $(document).on('click', 'a[href$=".mp4"]', function (e) {
            e.preventDefault();
            var videoUrl = $(this).attr('href');
            var $overlay = $('.video-overlay.file-mp4');
            var $video = $('#customOverlayVideo');
            // If video element doesn't exist, create it
            if ($video.length === 0) {
                $video = $('<video id="customOverlayVideo" controls style="width:100%"><source src="" type="video/mp4"></video>');
                $overlay.find('.video-container').append($video);
            }
            var $source = $video.find('source');
            if (videoUrl) {
                $source.attr('src', videoUrl);
                if ($video[0]) {
                    $video[0].load();
                    $video[0].currentTime = 0;
                    $video[0].play();
                }
                $overlay.css({
                    'opacity': '1',
                    'visibility': 'visible',
                    'z-index': '9999',
                    'display': 'block'
                });
            }
        });

    });
      document.addEventListener('DOMContentLoaded', function() {
        var iframe = document.getElementById('youtube-iframe');
        if (iframe) {
            var src = iframe.getAttribute('src');
            // Convert standard YouTube URL to embed and add autoplay
            var match = src.match(/[?&]v=([^&#]+)/);
            if (match && match[1]) {
                var embedUrl = 'https://www.youtube.com/embed/' + match[1] + '?autoplay=1&mute=1';
                iframe.setAttribute('src', embedUrl);
            } else if (src.includes('youtube.com/embed/')) {
                // If already embed, just add autoplay if not present
                if (!src.includes('autoplay=1')) {
                    var joinChar = src.includes('?') ? '&' : '?';
                    iframe.setAttribute('src', src + joinChar + 'autoplay=1&mute=1');
                }
            }
        }
    });
})(jQuery);

// Remove the video tag and clear source on close
$('.video-overlay.file-mp4 .closeVideo').on('click', function () {
    var $overlay = $('.video-overlay.file-mp4');
    var $video = $('#customOverlayVideo');
    if ($video.length) {
        var $source = $video.find('source');
        if ($video[0]) {
            $video[0].pause();
            $source.attr('src', ''); // Clear the source
            $video[0].load(); // Reset video element
        }
        $video.remove(); // Remove the video tag from DOM
    }
    $overlay.hide();
    $overlay.css({
        'display': 'none',
        'visibility': 'hidden',
        'z-index': '-1'
    });
});

// Also remove video tag and clear source on overlay click outside video container
$('.video-overlay.file-mp4').on('click', function (e) {
    if ($(e.target).closest('.video-container').length === 0) {
        var $overlay = $('.video-overlay.file-mp4');
        var $video = $('#customOverlayVideo');
        var $source = $video.find('source');
        $video[0] && $video[0].pause();
        $source.attr('src', ''); // Clear the source
        $video.load(); // Reset video element
        $overlay.hide();
        $video.remove();
        $overlay.css({
            'display': 'none',
            'visibility': 'hidden',
            'z-index': '-1'
        });
    }
});